export const RequiredContactsFields = [
  'contact_type',
  'newsletter_subscribe',
  'email',
  'first_name',
  'last_name',
];

export const maxContactsListValue = 5001;
